"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var jsbi_1 = __importDefault(require("jsbi"));
// prettier-ignore
var FORMAT_TYPE_LEN_DICT = {
    'b': 1,
    'w': 2,
    'd': 4,
    'q': 8,
};
function formatQuery(format) {
    var e_1, _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var result = [];
    var half = null;
    var argStack = Array.from(args);
    var escaped = false;
    try {
        for (var format_1 = __values(format), format_1_1 = format_1.next(); !format_1_1.done; format_1_1 = format_1.next()) {
            var char = format_1_1.value;
            if (escaped) {
                escaped = false;
                var value = argStack.shift();
                if (char in FORMAT_TYPE_LEN_DICT) {
                    var numberValue = jsbi_1.default.BigInt(value);
                    for (var byte = FORMAT_TYPE_LEN_DICT[char] - 1; byte >= 0; byte--) {
                        var v = jsbi_1.default.signedRightShift(numberValue, jsbi_1.default.BigInt(byte * 8));
                        v = jsbi_1.default.bitwiseAnd(v, jsbi_1.default.BigInt(0xff));
                        result.push(jsbi_1.default.toNumber(v));
                    }
                }
                else if (char === 'x' || char === 's') {
                    var uint8ArrayValue = utils_1.assertUint8Array(value);
                    var bufferLength = uint8ArrayValue.byteLength;
                    if (char === 's') {
                        bufferLength += 1;
                    }
                    result.push((bufferLength >> 8) & 0xff);
                    result.push(bufferLength & 0xff);
                    result.push.apply(result, __spread(uint8ArrayValue));
                    if (char === 's') {
                        result.push(0);
                    }
                }
                else if (char === '*') {
                    if (value instanceof Uint8Array) {
                        result.push.apply(result, __spread(value));
                    }
                    else {
                        utils_1.assert(false, "Unexpected type for value");
                    }
                }
                else {
                    utils_1.assert(false, "Unrecognized format char " + char);
                }
                continue;
            }
            if (char === '%') {
                utils_1.assert(half === null, "Expected \"half\" to be null");
                escaped = true;
                continue;
            }
            if (char === ' ') {
                continue;
            }
            if (half === null) {
                half = char;
            }
            else {
                result.push(Number.parseInt(half + char, 16));
                half = null;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (format_1_1 && !format_1_1.done && (_a = format_1.return)) _a.call(format_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return new Uint8Array(result).buffer;
}
exports.formatQuery = formatQuery;
function scanQuery(query, format) {
    var e_2, _a;
    var result = [];
    var inputStack;
    if (query instanceof ArrayBuffer) {
        inputStack = Array.from(new Uint8Array(query));
    }
    else {
        inputStack = query;
    }
    var initialLength = inputStack.length;
    var half = null;
    var escaped = false;
    try {
        for (var format_2 = __values(format), format_2_1 = format_2.next(); !format_2_1.done; format_2_1 = format_2.next()) {
            var char = format_2_1.value;
            if (escaped) {
                escaped = false;
                if (char === '?') {
                    inputStack.shift();
                    continue;
                }
                if (char in FORMAT_TYPE_LEN_DICT) {
                    var value = jsbi_1.default.BigInt(0);
                    for (var byte = FORMAT_TYPE_LEN_DICT[char] - 1; byte >= 0; byte--) {
                        var v = jsbi_1.default.BigInt(inputStack.shift());
                        v = jsbi_1.default.leftShift(v, jsbi_1.default.BigInt(byte * 8));
                        value = jsbi_1.default.bitwiseOr(value, v);
                    }
                    result.push(value);
                }
                else if (char === 's' || char === 'x') {
                    var length = (inputStack.shift() << 8) | inputStack.shift();
                    var newInputStack = inputStack.splice(length);
                    var buffer = new Uint8Array(inputStack);
                    inputStack = newInputStack;
                    if (char === 's') {
                        result.push(buffer);
                        // result.push(value.substring(0, value.length - 1));
                    }
                    else {
                        result.push(buffer);
                    }
                }
                else if (char === '*') {
                    var buffer = new Uint8Array(inputStack.splice(0));
                    result.push(buffer);
                }
                else if (char === '#') {
                    var value = new Uint8Array(inputStack.splice(0));
                    result.push(value);
                }
                else {
                    throw new Error("Unrecognized format char " + char);
                }
                continue;
            }
            if (char === '%') {
                utils_1.assert(half === null);
                escaped = true;
                continue;
            }
            if (char === ' ') {
                continue;
            }
            if (half === null) {
                half = char;
            }
            else {
                var inputValue = inputStack.shift();
                var formatValue = Number.parseInt(half + char, 16);
                if (formatValue != inputValue) {
                    var i = initialLength - inputStack.length - 1;
                    throw new Error("Format and input mismatch at " + i + ": expected " + formatValue + ", got " + inputValue);
                }
                half = null;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (format_2_1 && !format_2_1.done && (_a = format_2.return)) _a.call(format_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    utils_1.assert(inputStack.length === 0, inputStack.length + " Bytes remaining to parse");
    return result;
}
exports.scanQuery = scanQuery;
function BCD2int(bcd /* max 32 bits */) {
    var value = 0;
    var nibble = 0;
    while (bcd !== 0) {
        var nibbleValue = bcd & 0xf;
        bcd = bcd >>> 4;
        value += nibbleValue * Math.pow(10, nibble);
        nibble += 1;
    }
    return value;
}
exports.BCD2int = BCD2int;
function int2BCD(value, length) {
    var _a;
    if (length === void 0) { length = 1; }
    if (length > 4) {
        throw new Error("Unsupported length. Max allowed is 4");
    }
    if (value > Math.pow(10, length * 2) - 1) {
        throw new Error("Value " + value + " cannot fit in " + length + " bytes in BCD");
    }
    var bcd = 0;
    var nibble = 0;
    var nibbleValue;
    while (value) {
        _a = __read([Math.floor(value / 10), value % 10], 2), value = _a[0], nibbleValue = _a[1];
        bcd |= nibbleValue << (4 * nibble);
        nibble += 1;
    }
    return bcd;
}
exports.int2BCD = int2BCD;
//# sourceMappingURL=query-utils.js.map